module.exports = __webpack_public_path__ + "img/041-paraguay.2bc8f169.svg";